import './App.css';
import AppRouter from './Router/Router';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
